/** Ngôn ngữ định dạng số/ngày — một chỗ duy nhất. */
const LOCALE = 'vi-VN';

/** Số tiền VND có dấu phân cách (`3.900.643.479`). `null`/`undefined` coi như 0. */
export function formatMoney(value: number | undefined | null): string {
  return (value ?? 0).toLocaleString(LOCALE);
}

/** Khoảng thời gian dạng "5 phút trước". Quá 1 ngày thì trả về ngày dd/mm/yyyy. */
export function formatRelativeTime(date: Date | string | null | undefined): string {
  if (!date) return '';

  const then = new Date(date).getTime();
  const minutes = Math.floor((Date.now() - then) / 60_000);

  if (minutes < 1) return 'Vài giây trước';
  if (minutes < 60) return `${String(minutes)} phút trước`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${String(hours)} giờ trước`;

  return new Date(then).toLocaleDateString(LOCALE);
}
